(function () {
  var isCursorInit;
  var initCursor = function (section) {
    if (!section || !section.classList || !section.classList.contains("text-banner-section")) return;

    var contentSection = section.querySelector(".text-banner__wrapper");
    if (!contentSection) return;

    // Fixed line: Safe data retrieval
    var cursorData = contentSection.getAttribute('data-cursor') || "false";
    var isCursorExist = false;
    
    try {
      isCursorExist = JSON.parse(cursorData);
    } catch (e) {
      isCursorExist = false;
    }

    if (!isCursorExist) return;

    var imgCursorEl = section.querySelector(".text-banner__image-wrapper");
    if (!imgCursorEl) return;

    var currentX = 0, currentY = 0, targetX = 0, targetY = 0;
    var easingFactor = 0.19;
    var isAnimating = false;

    var animateCursor = function () {
      isAnimating = true;
      currentX += (targetX - currentX) * easingFactor;
      currentY += (targetY - currentY) * easingFactor;
      imgCursorEl.style.left = currentX + "px";
      imgCursorEl.style.top = currentY + "px";

      if (Math.abs(targetX - currentX) > 0.1 || Math.abs(targetY - currentY) > 0.1) {
        requestAnimationFrame(animateCursor);
      } else {
        isAnimating = false;
      }
    };

    var handleMouseMove = function (e) {
      var contentRect = contentSection.getBoundingClientRect();
      var imgCursorElRect = imgCursorEl.getBoundingClientRect();
      var sectionBtn = contentSection.querySelector(".text-banner__btn");
      var sectionTextLinks = contentSection.querySelectorAll(".text-banner__heading a, .text-banner__description a");

      var isOverLink = false;
      for (var i = 0; i < sectionTextLinks.length; i++) {
        var linkRect = sectionTextLinks[i].getBoundingClientRect();
        if (e.clientX > linkRect.left - 12 && e.clientX < linkRect.right + 12 && e.clientY > linkRect.top - 12 && e.clientY < linkRect.bottom + 12) {
          isOverLink = true;
          break;
        }
      }

      var isOverButton = false;
      if (sectionBtn) {
        var btnRect = sectionBtn.getBoundingClientRect();
        isOverButton = (e.clientX > btnRect.left - 12 && e.clientX < btnRect.right + 12 && e.clientY > btnRect.top - 12 && e.clientY < btnRect.bottom + 12);
      }

      targetX = e.clientX - contentRect.left - (imgCursorElRect.width / 2);
      targetY = e.clientY - contentRect.top - (imgCursorElRect.height / 2);

      var isOutOfBounds = (targetY > contentRect.height - (imgCursorElRect.height / 2) || targetY < 0 - (imgCursorElRect.height / 2));

      if (isOverButton || isOutOfBounds || isOverLink) {
        imgCursorEl.classList.remove("cursor-active");
      } else {
        imgCursorEl.classList.add("cursor-active");
      }

      if (!isAnimating) animateCursor();
    };

    var handleMouseEnter = function (e) {
      var contentRect = contentSection.getBoundingClientRect();
      var imgCursorElRect = imgCursorEl.getBoundingClientRect();
      targetX = currentX = e.clientX - contentRect.left - (imgCursorElRect.width / 2);
      targetY = currentY = e.clientY - contentRect.top - (imgCursorElRect.height / 2);
      imgCursorEl.style.left = currentX + "px";
      imgCursorEl.style.top = currentY + "px";
      imgCursorEl.classList.add("cursor-active");
    };

    var handleMouseLeave = function () {
      imgCursorEl.classList.remove("cursor-active");
    };

    if (typeof ResizeObserver !== 'undefined') {
      var observer = new ResizeObserver(function () {
        if (window.innerWidth >= 750 && window.matchMedia("(pointer:fine)").matches) {
          if (!isCursorInit) {
            contentSection.addEventListener("mouseenter", handleMouseEnter);
            contentSection.addEventListener("mousemove", handleMouseMove);
            contentSection.addEventListener("mouseleave", handleMouseLeave);
            isCursorInit = true;
          }
        } else {
          if (isCursorInit) {
            contentSection.removeEventListener("mouseenter", handleMouseEnter);
            contentSection.removeEventListener("mousemove", handleMouseMove);
            contentSection.removeEventListener("mouseleave", handleMouseLeave);
            isCursorInit = false;
          }
        }
      });
      observer.observe(section);
    }
  };

  // Safe execution
  var currentScript = document.currentScript;
  if (currentScript && currentScript.parentElement) {
    initCursor(currentScript.parentElement);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initCursor(event.target);
  });
})();